import { Amplify } from 'aws-amplify';
import {
  signIn, signOut, confirmSignIn, getCurrentUser, fetchAuthSession,
  setUpTOTP, verifyTOTPSetup, updateMFAPreference,
  resetPassword, confirmResetPassword, updatePassword,
} from 'aws-amplify/auth';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env['VITE_COGNITO_USER_POOL_ID'],
      userPoolClientId: import.meta.env['VITE_COGNITO_CLIENT_ID'],
    },
  },
});

export {
  signIn, signOut, confirmSignIn, getCurrentUser, fetchAuthSession,
  setUpTOTP, verifyTOTPSetup, updateMFAPreference,
  resetPassword, confirmResetPassword, updatePassword,
};

export async function getAuthUser() {
  try {
    const user = await getCurrentUser();
    return {
      sub: user.userId,
      email: user.signInDetails?.loginId ?? '',
    };
  } catch {
    return null;
  }
}
